import React, { FC, useEffect, useState } from "react";

import { ApiCallStatus } from "../../../api-http/types";
import { Button } from "../../buttons/button";
import { Modal } from "../../modal";
import { RichText } from "../../rich-text";
import { Spinner } from "../../spinner";
import { RequestInfoFormProps } from "./form";

export interface ResponseModalProps extends Pick<RequestInfoFormProps, "type"> {
  responseStatus: ApiCallStatus;
  labels: Record<string, string | null>;
  isOpen: boolean;
  onClose: () => void;
}

interface APIResult {
  title: string | null;
  body: string | null;
  cta: string | null;
}

export const ResponseModal: FC<ResponseModalProps> = ({
  responseStatus,
  labels,
  isOpen,
  onClose,
  type,
}) => {
  const [result, setResult] = useState<APIResult | null>(null);

  useEffect(() => {
    if (!isOpen) setResult(null);
    else if (responseStatus === ApiCallStatus.LOADING) {
      setResult({
        title: labels[`${type}_loading_title`],
        body: labels[`${type}_loading_body`],
        cta: null,
      });
    } else if (responseStatus === ApiCallStatus.SUCCESS) {
      setResult({
        title: labels[`${type}_success_title`],
        body: labels[`${type}_success_body`],
        cta: labels[`${type}_success_cta`],
      });
    } else {
      setResult({
        title: labels[`${type}_unknown-error_title`],
        body: labels[`${type}_unknown-error_body`],
        cta: labels[`${type}_unknown-error_cta`],
      });
    }
  }, [responseStatus, setResult, type, isOpen, labels]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="container p-2 max-w-lg flex flex-col gap-4">
        {result?.title && <h3 className="text-primary text-3xl">{result.title}</h3>}
        {result?.body && <RichText raw={result.body} className="text-lg" />}
        {responseStatus === ApiCallStatus.LOADING && <Spinner className="mx-auto" size="large" />}
        <div className="flex items-center justify-center gap-4 mx-[10%]">
          {result?.cta && (
            <Button variant="primary" onClick={onClose} size="sm">
              {result?.cta}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};
